import {FacePart} from "../../common";

export default new FacePart({
	defs: [

	],
	render () {
		return `
			<g transform="translate(2.000000, 52.000000)" fill-opacity="0.699999988">
				<path d="M40,15 C40,22.7319865 46.2680135,29 54,29 L54,29 C61.7319865,29 68,22.7319865 68,15"/>
			</g>
		`;
	},
});



// WEBPACK FOOTER //
// ./src/face/mouth/basic.js